// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
import { DISPLAY_STATUSES } from "../../../../../../../consts/booking"
import type { DisplayStatusInput } from "../../../../../../../records/bookingInput"
import {
  InvalidDataReceiveAction,
  GeneralModule,
} from "../../../../../../../services/tracking/constants/trackingEvents"
import mmbTrack from "../../../../../../../services/tracking/mmbTrack"
import type { DisplayStatus } from "../../../../../../../types/primitiveTypes"

const mappedDisplayStatuses: Partial<Record<DisplayStatusInput, DisplayStatus>> = {
  cancelled: DISPLAY_STATUSES.CANCELLED,
  change_in_progress: DISPLAY_STATUSES.CHANGE_IN_PROGRESS,
  confirmed: DISPLAY_STATUSES.CONFIRMED,
  locked: DISPLAY_STATUSES.LOCKED,
  processing: DISPLAY_STATUSES.PROCESSING,
  refunded: DISPLAY_STATUSES.REFUNDED,
  refunding: DISPLAY_STATUSES.REFUNDING,
  traveled: DISPLAY_STATUSES.TRAVELED,
  not_booked: DISPLAY_STATUSES.NOT_BOOKED,
}

export default function mapperDisplayStatus(displayStatus: DisplayStatusInput): DisplayStatus {
  if (!mappedDisplayStatuses[displayStatus]) {
    mmbTrack(
      {
        module: GeneralModule,
        action: InvalidDataReceiveAction,
        detail: "unexpected display status",
      },
      { displayStatus },
    )
    return DISPLAY_STATUSES.PROCESSING
  }

  return mappedDisplayStatuses[displayStatus]
}
